export default {
  "related.info.title": "Related Information",
  "related.category.title": "Category",
  "related.about.title": "About us",
  "related.event.eventsMain": "LINK-J Events/LINK-J Supported Events",
  "related.event.coSponsorship": "Co-sponsorship",
  "related.event.memberEvent": "Special Member Events",
  "related.event.all": "All Events",
  "related.about.greetings": "Message from the Chairman of the Board",
  "related.about.why": "Why in Nihonbashi",
  "related.about.overseas": "Overseas Collaborations",
  "related.about.message": "Messages of Support",
  "related.about.supporter": "Supporters",
  "related.about.business.company": "Our Activities",
  "related.about.introduction.corporate": "Special Membership Directory",
  "related.about.business.organization": "Organization",
  "related.webpage.greetings": "Message from the Chairman of the Board",
  "related.webpage.whyInNihonbashi": "Why in Nihonbashi",
  "related.webpage.whatsLinkJWest": "What's LINK-J WEST",
  "related.webpage.domesticAndInternationalCooperation":
    "Overseas Collaborations", // 英語版にのみ存在
  "related.webpage.supportMessages": "Messages of Support", // 英語版にのみ存在
  "related.webpage.supporterIntroduction": "Supporters", // 英語版にのみ存在
  "related.webpage.businessContents": "Our Activities", // 英語版にのみ存在
  "related.webpage.specialMemberList": "List of Special Members",
  "related.webpage.organizationOverview": "Organization", // 英語版にのみ存在

  "breadcrumbs.about": "About us",
  "breadcrumbs.about.introduction-corporate": "List of Special members", // same as URL structure

  "related.news.topics": "",
  "related.news.pressRelease": "",
  "related.news.media": "",
  "related.news.overseas": "",
  "related.news.newsEvents": "",
  "related.news.program": "",
  "related.news.sponsorship": "",
  "related.news.list": "",
  "related.eventReport.main": "",
  "related.eventReport.coSponsorship": "",
  "related.event.archive": "",
  "related.event.list": "",
  "related.eventReport.memberEvent": "",
  "related.eventReport.attend": "",
  "related.eventReport.list": "",
  "related.sandbox.scoop": "",
  "related.sandbox.sandbox": "",
  "related.sandbox.list": "",
  "related.interview.special-interviews": "",
  "related.interview.start-up-interviews": "",
  "related.interview.supporter": "",
  "related.interview.serial-column": "",
  "related.interview.supporter-column": "",
  "related.interview.column": "",
  "related.interview.link-j-staff-blog": "",
  "related.interview.list": "",
  "related.bulletinboard.pressRelease": "",
  "related.bulletinboard.news": "",
  "related.bulletinboard.bulletinBoardsRecruit": "",
  "related.bulletinboard.bulletinBoardsEvent": "",
} as const;
